import {Divider, Flex, Spacer, Text} from "@chakra-ui/react";
import SentimentFetcher from "./SentimentFetcher";
import SentimentSelector from "./SentimentSelectorButton";
import ReviewReader from "./ReviewReader";
import React from "react";


export default function SentimentAnalysis({
                                              productIds,
                                              renderReviews,
                                              setRenderReviews,
                                              reviewAspect,
                                              setReviewAspect,
                                              reviewSentiment,
                                              setReviewSentiment,
                                              handleReviewUpdate,
                                              startDate,
                                              endDate
                                          }) {


    return (
        <>
            <Text fontSize='xl' mt='30px' fontWeight="bold">Aspects</Text>
            <Divider/>
            <SentimentFetcher product_ids={productIds} startDate={startDate} endDate={endDate}
                              handleClickFn={handleReviewUpdate} selectedAspect={reviewAspect}/>
            <Flex direction='row' mt='30px'>
                <Text fontSize='xl' fontWeight="bold">Reviews</Text>
                <Spacer/>
                <SentimentSelector reviewSentiment={reviewSentiment} setReviewSentiment={setReviewSentiment}/>
            </Flex>
            <Divider mt="2px"/>
            {renderReviews ?
                <ReviewReader renderReviews={renderReviews}
                              product_ids={productIds}
                              aspect={reviewAspect}
                              sentiment={reviewSentiment}
                              setReviewSentiment={setReviewSentiment}
                              startDate={startDate}
                              endDate={endDate}/> : null}
        </>
    )
}